// ======================================================================
// File Name       : report
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const REPORT_RECEIVE_REPORT_LIST = 'REPORT_RECEIVE_REPORT_LIST';
export const REPORT_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG = 'REPORT_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG';
export const REPORT_INIT_DATA_FOR_REPORT_REGISTER_DIALOG = 'REPORT_INIT_DATA_FOR_REPORT_REGISTER_DIALOG';
export const REPORT_UPDATE = 'REPORT_UPDATE';
export const OPEN_REPORT_DIALOG = 'OPEN_REPORT_DIALOG';
export const REPORT_LIST_INIT_SEARCH_INFO = 'REPORT_LIST_INIT_SEARCH_INFO';
export const REPORT_LIST_GET_GROUP_LIST = 'REPORT_LIST_GET_GROUP_LIST';
// Distribution Report List
export const DISTRIBUTION_REPORT_SEARCH = 'DISTRIBUTION_REPORT_SEARCH';
export const DISTRIBUTION_REPORT_GET = 'DISTRIBUTION_REPORT_GET';
export const DISTRIBUTION_REPORT_COUNT = 'DISTRIBUTION_REPORT_COUNT';
export const OPEN_ASSIGNMENT_DISTRIBUTION_REPORT_DIALOG = 'OPEN_ASSIGNMENT_DISTRIBUTION_REPORT_DIALOG';
export const DISTRIBUTION_REPORT_USER_LIST_SEARCH = 'DISTRIBUTION_REPORT_USER_LIST_SEARCH';
export const DISTRIBUTION_REPORT_CHECKING_COUNT = 'DISTRIBUTION_REPORT_CHECKING_COUNT';
export const DISTRIBUTION_REPORT_SET_MANAGEMENT_AUTHORITY_LIST = 'DISTRIBUTION_REPORT_SET_MANAGEMENT_AUTHORITY_LIST';
export const DISTRIBUTION_REPORT_UPDATE = 'DISTRIBUTION_REPORT_UPDATE';
export const DISTRIBUTION_REPORT_RESET_UPDATE_RESULT = 'DISTRIBUTION_REPORT_RESET_UPDATE_RESULT';
export const DISTRIBUTION_REPORT_AUTHORITY_LIST = 'DISTRIBUTION_REPORT_AUTHORITY_LIST';
export const DISTRIBUTION_REPORT_ASSIGNMENT_RESET_INIT = 'DISTRIBUTION_REPORT_ASSIGNMENT_RESET_INIT';
export const DISTRIBUTION_REPORT_RESET_INIT = 'DISTRIBUTION_REPORT_RESET_INIT';
export const DISTRIBUTION_REPORT_UPDATE_SEARCH_INFO = 'DISTRIBUTION_REPORT_UPDATE_SEARCH_INFO';
export const DISTRIBUTION_REPORT_DETAIL_UPDATE_SEARCH_INFO = 'DISTRIBUTION_REPORT_DETAIL_UPDATE_SEARCH_INFO';
export const DISTRIBUTION_REPORT_DETAIL_UPDATE_USER_LIST_INFO = 'DISTRIBUTION_REPORT_DETAIL_UPDATE_USER_LIST_INFO';
export const DISTRIBUTION_REPORT_GROUP_LIST = 'DISTRIBUTION_REPORT_GROUP_LIST';

// Unsubmitted report
export const UNSUBMITTED_REPORT_SEARCH = 'UNSUBMITTED_REPORT_SEARCH';
export const UNSUBMITTED_REPORT_GET = 'UNSUBMITTED_REPORT_GET';
export const UNSUBMITTED_REPORT_USER_LIST_SEARCH = 'UNSUBMITTED_REPORT_USER_LIST_SEARCH';
export const UNSUBMITTED_REPORT_GROUP_LIST = 'UNSUBMITTED_REPORT_GROUP_LIST';
export const UNSUBMITTED_REPORT_RESET_INIT = 'UNSUBMITTED_REPORT_RESET_INIT';
export const UNSUBMITTED_REPORT_UPDATE_SEARCH_INFO = 'UNSUBMITTED_REPORT_UPDATE_SEARCH_INFO';
